var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zadi-session-volunteers"},[_c('ag-table',{attrs:{"data-source-api":_vm.getAssignedVolunteers,"grid-options":_vm.gridOptions,"permissions":{},"rtl":false,"is-entities-response":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }